import React, {
  createContext,
  useReducer,
  ReactNode,
  useEffect,
  useRef,
} from "react";
import { appStateReducer } from "./AppReducer";
import {
  ChatHistoryLoadingState,
  CosmosDBHealth,
  historyList,
  historyEnsure,
  CosmosDBStatus,
  SingleConversation,
} from "../api";
import { Conversation } from "../api";

export interface AppState {
  isChatHistoryOpen: boolean;
  isPromtPanelOpen: boolean;
  chatHistoryLoadingState: ChatHistoryLoadingState;
  isCosmosDBAvailable: CosmosDBHealth;
  chatHistory: Conversation[] | null;
  filteredChatHistory: Conversation[] | null;
  currentChat: Conversation | null;
  singleCurrentChat: Conversation | any;
  selectedAI: string | null;
  regenrateValue: string | null;
  clearChatHistory: string | null;
  tryitPrompt: string | null;
  subselectedAI: string | null;
  defaultModel: any | null;
  currentQuestion: string;
  isTextAreaFocused: boolean;
  isLiveSeachActive: boolean;
  enteredQuestion: string;
  converId: any;
  isFetchingMessages: boolean;
  PrivacyFollowups: any;
  SubCatagorybutton: boolean;
  filteredResults: { Title: string; Question: string }[] | null;
  modelDetails: any[];
  modelCategory: any[];
  appCategory: any[];
  selectedModel: string | null;
  selectedApp: string | null;
  filteredChatHistoryByModel?: Conversation[] | null;
   selectedSubCategory: string | null;
}

// Define action types for reducer
export type Action =
  | { type: "DROPDOWN_ITEM"; payload: string }
  | { type: "SUBDROPDOWN_ITEM"; payload: string }
  | { type: "REGENRATE_VALUE"; payload: string }
  | { type: "TOGGLE_CHAT_HISTORY" }
  | { type: "TOGGLE_PROMT_PANEL" }
  | { type: "CLEAR_CHAT_HISTORY"; payload: string }
  | { type: "SEND_TRYIT_PROMPT"; payload: string }
  | { type: "SET_COSMOSDB_STATUS"; payload: CosmosDBHealth }
  | {
      type: "UPDATE_CHAT_HISTORY_LOADING_STATE";
      payload: ChatHistoryLoadingState;
    }
  | { type: "UPDATE_CURRENT_CHAT"; payload: Conversation | null }
  | { type: "SINGLE_UPDATE_CURRENT_CHAT"; payload: Conversation | null }
  | { type: "UPDATE_FILTERED_CHAT_HISTORY"; payload: Conversation[] | null }
  | { type: "UPDATE_CHAT_HISTORY"; payload: Conversation }
  | { type: "UPDATE_CHAT_TITLE"; payload: Conversation }
  | { type: "DELETE_CHAT_ENTRY"; payload: string }
  | { type: "DELETE_CHAT_HISTORY" }
  | { type: "DELETE_CURRENT_CHAT_MESSAGES"; payload: string }
  | { type: "FETCH_CHAT_HISTORY"; payload: Conversation[] | null }
  | { type: "SET_DEFAULT_MODEL"; payload: any }
  | { type: "SET_CURRENT_QUESTION"; payload: string }
  | { type: "SET_TEXTAREA_FOCUS"; payload: boolean }
  | { type: "LIVESEARCh__ACTIVE"; payload: boolean }
  | { type: "ENTERED_QUESTION"; payload: string }
  | { type: "CONVERSATION_ID"; payload: any }
  | { type: "SET_FETCHING_MESSAGES"; payload: boolean }
  | { type: "PRIVACY_FOLLOWUP"; payload: [] }
  | { type: "SUBCATAGORYBUTTON"; payload: boolean }
  | {
      type: "SET_FILTERED_RESULTS";
      payload: { Title: string; Question: string }[] | null;
    }
  | { type: "SET_MODEL_CATEGORY"; payload: any[] }
  | { type: "SET_APP_CATEGORY"; payload: any[] }
  | { type: "SELECT_MODEL"; payload: string }
  | { type: "SELECT_APP"; payload: string }
  | { type: "SET_MODEL_DETAILS"; payload: any[] }
  | { type: "RESET_MODEL" }
  | { type: "RESET_APP" }
  | { type: "FILTERED_CHAT_HISTORY_BY_MODEL"; payload: Conversation[] | null }
  | { type: "SET_SUBCATEGORY"; payload: string | null };

// Define the initial state
const initialState: AppState = {
  isChatHistoryOpen: false,
  isPromtPanelOpen: false,
  chatHistoryLoadingState: ChatHistoryLoadingState.Loading,
  chatHistory: null,
  filteredChatHistory: null,
  currentChat: null,
  singleCurrentChat: null,
  selectedAI: "",
  subselectedAI: "azureblob-index-all",
  regenrateValue: null,
  clearChatHistory: null,
  tryitPrompt: null,
  isCosmosDBAvailable: {
    cosmosDB: false,
    status: CosmosDBStatus.NotConfigured,
  },
  defaultModel: null,
  currentQuestion: "",
  isTextAreaFocused: false,
  isLiveSeachActive: false,
  enteredQuestion: "",
  converId: "",
  isFetchingMessages: false,
  PrivacyFollowups: [],
  SubCatagorybutton: false,
  filteredResults: null,
  modelCategory: [],
  appCategory: [],
  modelDetails: [],
  selectedModel: null,
  selectedApp: null,
  filteredChatHistoryByModel: null,
  selectedSubCategory: null,
};

// Create Context
export const AppStateContext = createContext<
  | {
      state: AppState;
      dispatch: React.Dispatch<Action>;
    }
  | undefined
>(undefined);

type AppStateProviderProps = {
  children: ReactNode;
};

// Context Provider Component
export const AppStateProvider: React.FC<AppStateProviderProps> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(appStateReducer, initialState);
  const hasEnsuredCosmosDB = useRef(false);
  // useEffect(() => {
  //   const fetchChatHistory = async (): Promise<Conversation[] | null> => {
  //     try {
  //       const response = await historyList(state.selectedAI);

  //       dispatch({ type: "FETCH_CHAT_HISTORY", payload: response || null });
  //       return response || null;
  //     } catch (error) {
  //       dispatch({
  //         type: "UPDATE_CHAT_HISTORY_LOADING_STATE",
  //         payload: ChatHistoryLoadingState.Fail,
  //       });
  //       dispatch({ type: "FETCH_CHAT_HISTORY", payload: null });
  //       console.error("Error fetching chat history:", error);
  //       return null;
  //     }
  //   };

  //   const getHistoryEnsure = async () => {
  //     dispatch({
  //       type: "UPDATE_CHAT_HISTORY_LOADING_STATE",
  //       payload: ChatHistoryLoadingState.Loading,
  //     });
  //     try {
  //       const response = await historyEnsure();
  //       if (response?.cosmosDB) {
  //         const chatHistory = await fetchChatHistory();
  //         dispatch({
  //           type: "UPDATE_CHAT_HISTORY_LOADING_STATE",
  //           payload: chatHistory
  //             ? ChatHistoryLoadingState.Success
  //             : ChatHistoryLoadingState.Fail,
  //         });
  //         dispatch({ type: "SET_COSMOSDB_STATUS", payload: response });
  //       } else {
  //         dispatch({
  //           type: "UPDATE_CHAT_HISTORY_LOADING_STATE",
  //           payload: ChatHistoryLoadingState.Fail,
  //         });
  //         dispatch({ type: "SET_COSMOSDB_STATUS", payload: response });
  //       }
  //     } catch (error) {
  //       dispatch({
  //         type: "UPDATE_CHAT_HISTORY_LOADING_STATE",
  //         payload: ChatHistoryLoadingState.Fail,
  //       });
  //       dispatch({
  //         type: "SET_COSMOSDB_STATUS",
  //         payload: { cosmosDB: false, status: CosmosDBStatus.NotConfigured },
  //       });
  //     }
  //   };

  //   if (!hasEnsuredCosmosDB.current) {
  //     getHistoryEnsure().then(() => {
  //       hasEnsuredCosmosDB.current = true;
  //     });
  //   } else {
  //     fetchChatHistory();
  //   }
  // }, [state.selectedAI]);

  return (
    <AppStateContext.Provider value={{ state, dispatch }}>
      {children}
    </AppStateContext.Provider>
  );
};
